<template>
  <div class="main-box">
    <div class="content-main-bottom" >
        <div class="btm-left ">
          <div class="btm-left-head">
            <a-tabs :default-active-key="activeKey" type="line" :animation="true" size="large" style="font-size: 20px;">
              <a-tab-pane class="order-tab" :key="index" v-for="item,index in tabs" >
                <template #title>
                  <span :style="{ fontSize: '16px' }">{{item.label}}</span>
                </template>
                <div>
                  <div class="kline" v-if="item.id == 1">
                    <!-- 共富基金 -->
                    <notdate> </notdate>
                  </div>
                  <div class="kline" v-if="item.id == 2">
                    <!-- 奔富理财 -->
                    <notdate> </notdate>
                  </div>
                  <div class="kline" v-if="item.id == 3">
                    <!-- 双币理财 -->
                    <notdate> </notdate>
                  </div>
                  <div class="kline" v-if="item.id == 4">
                    <!-- 活币宝 -->
                    <div>
                      <div class="tag just">
                      <div>
                        <span>{{ $t('investment.subscribe') }}</span>
                        <span>{{ $t('easy_earn.redeem') }}</span>
                        <span>{{ $t('investment.interest_distribution') }}</span>
                      </div>
                      <div>
                        <a-space>
                          <a-button type="primary">{{ $t('investment.go_to_subscribe') }}</a-button>
                        </a-space>
                      </div>
                      </div>
                    </div>
                    <div class="kline-box">
                       <!-- 格子B -->
                    <div class="kline-content">
                      <div class="kline-title">{{ $t('futures.contract_type') }}</div>
                      <div class="select-box">
                        <a-select
                          class="flex-box"
                          direction="vertical"
                          :style="{
                            width: '120px',
                            backgroundColor: '#1d2126',
                          }"
                          :default-value="decimal"
                          size="large"
                        >
                          <a-option
                            :style="{
                              backgroundColor: '#1d2126',
                              color: '#fff',
                            }"
                            v-for="(item, index) in options"
                            :key="index"
                            @click="numSelect(item.value)"
                            >{{ item.label }}</a-option
                          >
                        </a-select>
                      </div>
                    </div>
                    <!-- 格子A -->
                    <div class="kline-content">
                      <div class="kline-title">{{ $t('order.start_time') }}</div>
                      <div> 
                        <a-range-picker
                          @change="onChange"
                          @select="onSelect"
                          :style="{backgroundColor: '#1d2126',marginRight:'16px'}"
                          size="large"
                        ></a-range-picker>
                      </div>
                    </div>
                   
                  </div>
                    <notdate> </notdate>
                  </div>
                </div>
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import notdate from "@/components/notdate/notdate.vue";
export default{
  components:{
    notdate
  },
  data(){
    return {
      tabs: [
        {
          id:'1',
          label:this.$t('investment.fund_product')
        },
        {
          id:'2',
          label:this.$t('investment.wealth_product')
        },
        {
          id:'3',
          label:this.$t('investment.dual_currency_product')
        },
        {
          id:'4',
          label:this.$t('investment.live_coin_treasure')
        }
      ],
      activeKey:0
    }
  }
}

</script>

<style lang="scss" scoped>
@import "./subscriptionHistory.scss";
</style>
